// extracted by mini-css-extract-plugin
export var action = "EnableBiometricPrompt-module--action--73716";
export var body = "EnableBiometricPrompt-module--body--56bd0";
export var content = "EnableBiometricPrompt-module--content--2114d";
export var icon = "EnableBiometricPrompt-module--icon--542e4";
export var subHeader = "EnableBiometricPrompt-module--subHeader--a5c67";